// extracted by mini-css-extract-plugin
var _1 = "field___D52qE";
var _2 = "text___jQufC";
export { _1 as "field", _2 as "text" }
